export { default } from './FooterCard';
